export default __webpack_public_path__ + "e8cc25dd71a197bf387b9cc1a0593ec7.png";